import Vue from 'vue'
import VueI18n from 'vue-i18n'
import FormatCurrency from '~utils/format-currency'

export const decorateAmount = (formattedCurrency: string, kind: string) => {
  if (kind === 'credit') return `+ ${formattedCurrency}`
  if (kind === 'debit') return `- ${formattedCurrency}`
  return formattedCurrency
}

export default (i18n: VueI18n, minimumFractionDigits = 0) => {
  Vue.filter('formatCurrency', (amount: number | null, currency: string, style = 'currency'): string => {
    if (typeof (amount) !== 'undefined' && typeof (currency) !== 'undefined' && amount !== null && currency != null) {
      return FormatCurrency.formatCents(amount, currency, i18n.locale, minimumFractionDigits, style)
    }
    return ''
  })
  Vue.filter('decorateAmount', decorateAmount)
}
